export enum ChurnStatus {
  NoRisk = 'No identifiable risk',
  Insufficient = 'Insufficient data',
  Low = 'Low risk',
  Moderate = 'Moderate risk',
  High = 'High risk',
}

type ChurnStatusDetailsMap = Record<Exclude<ChurnStatus, ChurnStatus.NoRisk>,
  { label: string; reason: string }>

export const ChurnStatusDetails: ChurnStatusDetailsMap = {
  [ChurnStatus.High]: {
    label: 'Churn risk high',
    reason: `Customer is likely to spend very little or nothing in the next 90 days — 
    more than 80% of their business is at risk of being lost.`,
  },
  [ChurnStatus.Moderate]: {
    label: 'Churn risk moderate',
    reason: `Customer is expected to continue purchasing in the next 90 days, 
    but not at normal levels — likely to retain only around 60% or less of their usual business.`,
  },
  [ChurnStatus.Low]: {
    label: 'Churn risk low',
    reason: `Customer's recent spend is down, but they tend to make larger purchases 
    in the next 90 days. If that holds, you'll likely retain at least 60% of their business — though some loss is still expected.`,
  },
  [ChurnStatus.Insufficient]: {
    label: 'Churn insufficient data',
    reason: `Not enough historical data to confidently predict 
      this customer's future spending or churn risk.`,
  },
};
